import React, { useState } from "react";

import HeroBgImg   from "../../asset/images/ewaste/hero-bg.webp";
import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";
import EwasteImg1  from "../../asset/images/ewaste/ewaste-1.webp";
import EwasteImg2  from "../../asset/images/ewaste/ewaste-1.webp";
import EwasteImg3  from "../../asset/images/ewaste/ewaste-1.webp";
import RecyclingImg1 from "../../asset/images/ewaste/recycling-1.webp";
import RecyclingImg2 from "../../asset/images/ewaste/recycling-2.webp";
import RecyclingImg3 from "../../asset/images/ewaste/recycling-3.webp";
import DoIconImg   from "../../asset/images/ewaste/icon-do.svg";
import DontIconImg from "../../asset/images/ewaste/icon-dont.svg";


const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ew { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .ew-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
  }

  .ew-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .ew-hero-overlay {
    position: absolute;
    inset: 0;
  }

  .ew-hero-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
  }

  .ew-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 15px;
  }

  .ew-hero-divider {
    width: 479px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 15px;
  }

  .ew-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 160%;
    max-width: 479px;
  }

  .ew-hero-nav {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: #EB2019;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    display:none;
    
  }

  .ew-hero-nav-item {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    padding: 20px;
    height: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;
    border-right: 1px solid #A40000;
    transition: background 0.15s;
    background: #B91E1A
  }

  .ew-hero-nav-item:first-child { border-left: 1px solid rgba(255,255,255,0.25); }
  .ew-hero-nav-item:hover { background: rgba(255,255,255,0.12); }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .ew-breadcrumb {
    width: 100%;
    padding: 40px 0 0 0;
  }

  .ew-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .ew-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: color 0.15s;
  }

  .ew-bc-item:hover { color: #EB2019; }

  .ew-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
  
    margin: 0 8px;
    flex-shrink: 0;
  }

  .ew-bc-sep svg { display: block; }
  .ew-bc-item.active { color: #202020; font-weight: 500; }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .ew-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0px 102px;
  }

  /* ══════════════════════════════════════════
     SECTION HEADING (red)
  ══════════════════════════════════════════ */
  .ew-section-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 60px;
    line-height: 140%;
  }

  .ew-collection-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 15px;
    line-height: 140%;
  }

  /* ══════════════════════════════════════════
     3. INTRO SECTION
  ══════════════════════════════════════════ */
  .ew-intro-section {
    padding: 80px 0 0px 0;
  }

  .ew-intro-row {
    display: flex;
    align-items: center;
    gap: 66px;
    border-bottom: 1px solid #EB2019;
    padding-bottom: 80px;
    margin-bottom: 80px;
  }

  .ew-intro-left {
    flex: 0 0 617px;
    max-width: 617px;
  }

  .ew-intro-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 15px;
    line-height: 120%;
  }

  .ew-intro-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    margin-bottom: 15px;
  }

  .ew-intro-text:last-child { margin-bottom: 0; }

  .ew-intro-right {
    flex: 1;
    min-width: 0;
  }

  .ew-carousel {
    position: relative;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
  }

  .ew-carousel-track {
    display: flex;
    transition: transform 0.4s ease;
  }

  .ew-carousel-slide {
    min-width: 100%;
    flex-shrink: 0;
  }

  .ew-carousel-slide img {
    width: 100%;
    height: 460px;
    object-fit: cover;
    display: block;
    border-radius: 10px;
  }

  .ew-carousel-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 16px;
  }

  .ew-carousel-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #D9D9D9;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: background 0.2s;
  }

  .ew-carousel-dot.active {
    background: #EB2019;
  }

  /* ══════════════════════════════════════════
     4. BENEFITS SECTION
  ══════════════════════════════════════════ */
  .ew-benefits-section {
    padding: 0 0 80px 0;
  }

  .ew-benefits-divider {
    width: 100%;
    height: 1px;
    background: #EB2019;
    border: none;
    margin-bottom: 80px;
  }

  .ew-benefits-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }

  .ew-benefit-card {
    padding: 30px;
    background: #F2F5FA;
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 200px;
    border-radius: 10px;
  }

  .ew-benefit-card.even {
    background: #FFE6E5;
  }

  .ew-benefit-title {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
  }

  .ew-benefit-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     5. RECYCLING OF E-WASTE SECTION
  ══════════════════════════════════════════ */
  .ew-recycling-section {
    padding: 0 0 80px 0;
  }

  .ew-recycling-row {
    display: flex;
    align-items: flex-start;
    gap: 152px;
  }

  .ew-recycling-left {
    flex: 0 0 617px;
    max-width: 617px;
  }

  .ew-recycling-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 15px;
    line-height: 160%;
  }

  .ew-recycling-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  .ew-recycling-text strong {
    font-weight: 700;
  }

  .ew-recycling-right {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .ew-recycling-top-imgs {
    display: flex;
    gap: 30px;
  }

  .ew-recycling-top-imgs img {
    flex: 1;
    height: 250px;
    object-fit: cover;
    border-radius: 10px;
    display: block;
  }

  .ew-recycling-bottom-img {
    width: 100%;
    height: 260px;
    object-fit: cover;
    border-radius: 10px;
    display: block;
  }

  .ew-recycling-divider {
    width: 100%;
    height: 1px;
    background: #EB2019;
    border: none;
    margin-top: 80px;
  }

  /* ══════════════════════════════════════════
     6. DOS AND DON'TS
  ══════════════════════════════════════════ */
  .ew-dos-section {
    padding: 0 0 80px 0;
  }

  .ew-Do-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 60px;
    line-height: 160%;
  }

  .ew-dos-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 70px;
  }

  .ew-dos-col-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 30px;
    line-height: 120%;
  }

  .ew-dos-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .ew-dos-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    display: flex;
    align-items: flex-start;
    gap: 13px;
  }

  .ew-dos-icon {
    flex-shrink: 0;
    margin-top: 2px;
    display: block;
    width: 22px;
    height: 22px;
  }

  /* ══════════════════════════════════════════
     7. COLLECTION CENTERS — DESKTOP
  ══════════════════════════════════════════ */
  .ew-collection-section {
    padding: 0 0 120px 0;
  }

  .ew-collection-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    margin-bottom: 60px;
  }

  .ew-collection-text strong {
    font-weight: 600;
  }

  /* ══════════════════════════════════════════
     8. TABLE (desktop only)
  ══════════════════════════════════════════ */
  .ew-table-wrap {
    border: 1px solid #B8B8B8;
    border-radius: 0px;
    overflow: hidden;
  }

  .ew-table-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #202020;
    padding: 30px;
    background: #F6F6F6;
    border-bottom: 1px solid #B8B8B8;
  }

  .ew-table {
    width: 100%;
    border-collapse: collapse;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
  }

  .ew-table thead tr {
    background: #FFFFFF;
  }

  .ew-table thead th {
    padding: 20px 20px;
    text-align: left;
    font-weight: 500;
    color: #202020;
    font-size: 16px;
    border-bottom: 1px solid #B8B8B8;
    border-right: 1px solid #B8B8B8;
    white-space: nowrap;
  }

  .ew-table thead th:last-child {
    border-right: none;
  }

  .ew-table tbody tr {
    border-bottom: 1px solid #B8B8B8;
  }

  .ew-table tbody tr:last-child {
    border-bottom: none;
  }

  .ew-table tbody td {
    padding: 30px 20px;
    color: #202020;
    font-size: 16px;
    line-height: 120%;
    border-right: 1px solid #B8B8B8;
    vertical-align: top;
  }

  .ew-table tbody td:last-child {
    border-right: none;
  }

  .ew-table tbody tr:nth-child(odd) {
    background: #F6F6F6;
  }

  .ew-table tbody tr:nth-child(even) {
    background: #FFFFFF;
  }

  /* ══════════════════════════════════════════
     MOBILE COLLECTION LAYOUT
  ══════════════════════════════════════════ */
  .ew-mobile-collection { display: none; }
  .ew-desktop-collection { display: block; }

  /* Dropdown labeled border wrapper */
  .ew-mobile-dropdown-wrapper {
    border: 1px solid #D9D9D9;
    border-radius: 8px;
    padding: 10px 16px 14px 16px;
    margin-bottom: 20px;
    position: relative;
    background:#F6F6F6;
  }

  .ew-mobile-dropdown-label {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #202020;
    margin: 0px;
    display: inline-block;
    transform: translateY(-21px);

    background: #F6F6F6;
    padding: 0px;
  }

  /* State dropdown */
  .ew-state-dropdown-wrap {
    position: relative;
  }

  .ew-state-select {
    width: 100%;
    appearance: none;
    -webkit-appearance: none;
    background: transparent;
    border: none;
    padding: 0 30px 0 0;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #202020;
    cursor: pointer;
    outline: none;
  }

  .ew-state-select:focus {
    border-color: #EB2019;
  }

  .ew-dropdown-chevron {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: #202020;
  }

  /* Mobile card */
  .ew-mobile-card {
    border: 1px solid #D9D9D9;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
  }

  .ew-mobile-card-row {
    display: flex;
    align-items: flex-start;
    padding: 16px 16px;
    border-bottom: 1px solid #EBEBEB;
  }

  .ew-mobile-card-row:last-child {
    border-bottom: none;
  }

  .ew-mobile-card-label {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #202020;
    min-width: 120px;
    flex-shrink: 0;
    line-height: 160%;
  }

  .ew-mobile-card-sep {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #202020;
    margin: 0 12px;
    line-height: 160%;
    flex-shrink: 0;
  }

  .ew-mobile-card-value {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    flex: 1;
    white-space: pre-line;
  }

  /* ══════════════════════════════════════════
     9. CONTACT FOOTER
  ══════════════════════════════════════════ */
  .ew-contact-footer {
    margin-top: 120px;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    color: #202020;
    line-height: 120%;
  }

  .para { margin-bottom: 15px; }

  .ew-contact-footer strong {
    font-weight: 600;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .ew-hero              { height: 350px; }
    .ew-hero-content      { padding: 0 32px; }
    .ew-hero-title        { font-size: 30px; }
    .ew-hero-nav          { overflow-x: auto; justify-content: flex-start; }
    .ew-hero-nav-item     { padding: 0 18px; font-size: 13px; flex-shrink: 0; }
    .ew-breadcrumb        { padding: 24px 0 0 0; }
    .ew-breadcrumb-inner  { padding: 0 32px; }
    .ew-inner             { padding: 0 32px; }
    .ew-intro-section     { padding: 48px 0 0px 0; }
    .ew-intro-row         { flex-direction: column-reverse; gap: 32px; padding-bottom: 48px; margin-bottom: 48px; }
    .ew-benefits-divider  { margin-bottom: 48px; }
    .ew-intro-left        { flex: none; max-width: 100%; }
    .ew-carousel-slide img { height: 320px; }
    .ew-benefits-section  { padding: 0 0 48px 0; }
    .ew-benefits-grid     { grid-template-columns: repeat(2, 1fr); }
    .ew-recycling-section { padding: 0 0 48px 0; }
    .ew-recycling-row     { flex-direction: column-reverse; gap: 32px; }
    .ew-recycling-left    { flex: none; max-width: 100%; }
    .ew-recycling-divider { margin-top: 48px; }
    .ew-Do-heading        { margin-bottom: 24px; }
    .ew-recycling-right   { width: 100%; }
    .ew-recycling-top-imgs img { height: 160px; }
    .ew-recycling-bottom-img   { height: 160px; }
    .ew-dos-section       { padding: 0 0 48px 0; }
    .ew-table-title       { font-size: 14px; padding: 20px 20px; }
    .ew-table thead th    { font-size: 9px; padding: 10px 10px; }
    .ew-table tbody td    { font-size: 9px; padding: 10px 10px; }
    .ew-collection-section { padding: 0 0 48px 0; }
    .ew-collection-text   { margin-bottom: 24px; }
    .ew-section-heading   { font-size: 24px; margin-bottom: 24px; }
    .ew-intro-heading     { font-size: 24px; }
    .ew-contact-footer    { margin-top: 48px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .ew-hero              { height: 360px; }
    .ew-hero-content      { padding: 0 16px; }
    .ew-hero-title        { font-size: 24px; margin-bottom: 12px; }
    .ew-hero-divider      { width: 100%; }
    .ew-hero-nav          { overflow-x: auto; justify-content: flex-start; height: 44px; }
    .ew-hero-nav-item     { padding: 0 14px; font-size: 12px; flex-shrink: 0; }
    .ew-breadcrumb        { padding: 30px 0 0 0; }
    .ew-breadcrumb-inner  { padding: 0 16px; gap: 14px; }
    .ew-bc-item           { font-size: 14px; gap: 8px; }
    .ew-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .ew-inner             { padding: 0 16px; }
    .ew-intro-section     { padding: 60px 0 0px 0; }
    .ew-intro-row         { flex-direction: column-reverse; gap: 20px; padding-bottom: 30px; margin-bottom: 30px; }
    .ew-intro-left        { flex: none; max-width: 100%; }
    .ew-intro-heading     { font-size: 20px; }
    .ew-intro-text        { font-size: 14px; }
    .ew-carousel-slide img { height: 200px; }
    .ew-benefits-section  { padding: 0 0 30px 0; }
    .ew-benefits-grid     { grid-template-columns: 1fr; gap: 15px; }
    .ew-benefit-card      { padding: 20px 20px; gap: 10px; min-height: auto; }
    .ew-benefit-title     { font-size: 16px; }
    .ew-benefit-desc      { font-size: 14px; }
    .ew-benefits-divider  { margin-bottom: 30px; }
    .ew-recycling-section { padding: 0 0 0px 0; }
    .ew-recycling-row     { flex-direction: column-reverse; gap: 16px; }
    .ew-recycling-top-imgs { flex-direction: column; gap: 16px; }
    .ew-recycling-left    { flex: none; max-width: 100%; }
    .ew-recycling-heading { font-size: 20px; margin-bottom: 30px; }
    .ew-recycling-text    { font-size: 14px; }
    .ew-recycling-top-imgs img { height: 206px; }
    .ew-Do-heading        { margin-bottom: 15px; margin-top: 30px; }
    .ew-dos-col-title     { font-size: 16px; margin-bottom: 15px; }
    .ew-recycling-bottom-img   { height: 206px; }
    .ew-recycling-right   { width: 100%; gap: 16px; }
    .ew-dos-section       { padding: 0 0 30px 0; }
    .ew-recycling-divider { margin-top: 30px; }
    .ew-dos-row           { grid-template-columns: 1fr; gap: 30px; }
    .ew-dos-list li       { font-size: 14px; }
    .ew-collection-section { padding: 0 0 60px 0; }
    .ew-collection-text   { font-size: 14px; }
    .ew-section-heading   { font-size: 20px; margin-bottom: 15px; }
    .ew-contact-footer    { margin-top: 30px; font-size: 14px; }

    /* Switch to mobile card layout */
    .ew-desktop-collection { display: none; }
    .ew-mobile-collection  { display: block; }
    .ew-collection-text    { margin-bottom: 30px; }
  }
`;

const BcArrow = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M2 1l3 3-3 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChevronDown = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="ew-dropdown-chevron">
    <path d="M4 6.5l5 5 5-5" stroke="#202020" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const benefits = [
  {
    title: "Resource Recovery",
    desc: "E-waste contains many valuable, recoverable materials such as aluminum, copper, gold, silver, plastics, and ferrous metals. In order to conserve natural resources and the energy needed to produce new electronic equipment from virgin resources, electronic equipment can be refurbished, reused, and recycled instead of being landfilled.",
  },
  {
    title: "Environmental Hazard",
    desc: "E-waste also contains toxic and hazardous materials including mercury, lead, cadmium, beryllium, chromium, and chemical flame retardants, which have the potential to leach into our soil and water.",
  },
  {
    title: "Protects your surroundings",
    desc: "Safe recycling of outdated electronics promotes sound management of toxic chemicals such as lead and mercury.",
  },
  {
    title: "Conserves natural resources",
    desc: "Recycling recovers valuable materials from old electronics that can be used to make new products. As a result, we save energy, reduce pollution, reduce greenhouse gas emissions, and save resources by extracting fewer raw materials from the earth.",
  },
  {
    title: "Helps others",
    desc: "Donating your used electronics benefits your community by passing on ready-to-use or refurbished equipment to those who need it.",
  },
  {
    title: "Saves landfill space",
    desc: "E-waste is a growing waste stream. By recycling these items, landfill space is conserved.",
  },
];

const dos = [
  "Always look for information on the catalogue with your product for end-of-life equipment handling.",
  "Ensure that only Authorized Recyclers repair and handle your electronic products.",
  "Always call our E-waste Authorized Collection Centres/points to dispose products that have reached end-of life.",
  "Always drop your used electronic products, batteries or any accessories when they reach the end of their life at your nearest Authorized E-Waste Collection Centres/Points.",
  "Always disconnect the battery from product, and ensure any glass surface is protected against breakage.",
];

const donts = [
  "Do not dismantle your electronic Products on your own",
  'Do not throw electronics in bins having "Do not Dispose" sign.',
  "Do not give e-waste to informal (Kabbadi) and unorganized sectors like Local Scrap Dealer/ Rag Pickers.",
  "Do not dispose your product in garbage bins along with municipal waste that ultimately reaches landfills.",
];

const collectionPoints = [
  { sr: "01", state: "Delhi", location: "Rangpuri", logistic: "Professional Logistics Pvt.Ltd.", address: "198, 5/7 Mailepur Kothi, Next To Hero Honda Service Station, Rangpuri, Mahipalpur EXT, New Delhi, Delhi – 110037", toll: "18002749111", contact: "Rajkumar Poonia\n9312377783" },
  { sr: "02", state: "Haryana", location: "Gurugram", logistic: "Professional Logistics Pvt.Ltd.", address: "J-171, New Palam Vihar Phase-1, Gurgaon, Gurugram, Haryana 122017", toll: "18002749111", contact: "Mr BR Reddy\n09311060156" },
  { sr: "03", state: "Jharkhand", location: "Dhanbad", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No-45, UBD Rd, Ramson Arcade, Shastri Nagar, Dhanbad, Jharkhand – 826106", toll: "18002749111", contact: "Mr. Das\n09304233856\n0612 – 2525821" },
  { sr: "04", state: "Uttar Pradesh", location: "Noida", logistic: "Professional Logistics Pvt.Ltd.", address: "BH-122, Sector – 70, Noida, Uttar Pradesh 201301", toll: "18002749111", contact: "Mr. S. K. Mishra\n08350610579\n9311950579" },
  { sr: "05", state: "Manipur", location: "Manipur", logistic: "Professional Logistics Pvt.Ltd.", address: "Zonal Office: HN-34 Kundil Nagar Basistha Charali, Near Parinat Apartment, Guwahati-781029\nInfo@PackersMovers.Com", toll: "18002749111", contact: "Mr. Omprakash\n09434422131" },
  { sr: "06", state: "Maharashtra", location: "Mumbai", logistic: "Professional Logistics Pvt.Ltd.", address: "Plot-93, Gala No-01, Sector 19C Vashi Navi Mumbai – 400705", toll: "18002749111", contact: "Mr. Ranbir Singh\n09372960155\n022 – 2776967" },
  { sr: "07", state: "Maharashtra", location: "Pune", logistic: "Professional Logistics Pvt.Ltd.", address: "Plot No-24, Sec No-4, Shikshak Colony, Near Spine City, Moshi Pradhikaran, Pune – 412105", toll: "18002749111", contact: "Mr. Vedprakash\n09370939981\n09370661989" },
  { sr: "08", state: "Odisha", location: "Cuttack", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No- 37, Kathajodi Rd, Badambadi Colony, Cuttack, Odisha 753010", toll: "18002749111", contact: "Mr. Anuj Kumar\n9312377781\n9312377782" },
  { sr: "09", state: "Manipur", location: "Manipur", logistic: "Professional Logistics Pvt.Ltd.", address: "Zonal Office: HN-34 Kundil Nagar Basistha Charali, Near Parinat Apartment, Guwahati-781029\nInfo@PackersMovers.Com", toll: "18002749111", contact: "Mr. Omprakash\n09434422131" },
  { sr: "10", state: "Telangana", location: "Hyderabad", logistic: "Professional Logistics Pvt.Ltd.", address: "4, Block-3, 4th Shelter At 173, MFR Estates Near Old Check Post Old Bowenpally Secunderabad, Hyderabad – 500011", toll: "18002749111", contact: "Mr. Ajay Kumar\n09311899193\n09399696155" },
  { sr: "11", state: "Arunachal Pradesh", location: "Arunachal Pradesh", logistic: "Professional Logistics Pvt.Ltd.", address: "Zonal Office: HN-34 Kundil Nagar Basistha Charali, Near Parinat Apartment, Guwahati-781029\nInfo@PackersMovers.Com", toll: "18002749111", contact: "Mr.Sasharam\n09364025200\n09864048000" },
  { sr: "12", state: "Karnataka", location: "Bangalore", logistic: "Professional Logistics Pvt.Ltd.", address: "No.43 1st Floor 2nd Main G.O.LT.TL, Yeshwantpur, Bangalore – 560022", toll: "18002749111", contact: "Mr. Ratan Lal\n09343385015\n080 – 41227232" },
  { sr: "13", state: "Jharkhand", location: "Ranchi", logistic: "Professional Logistics Pvt.Ltd.", address: "Plot No– A, 25, Indrapuri Colony, Ranchi, Jharkhand 834003", toll: "18002749111", contact: "Mr. Das\n09304233856\n0612 – 2523821" },
  { sr: "14", state: "Tamil Nadu", location: "Chennai", logistic: "Professional Logistics Pvt.Ltd.", address: "27, Sakthi Nagar Phase II, Semerkuppam, Near Bokari Water Plant, Chennai – 60056", toll: "18002749111", contact: "Mr. Firoj Khan\n09843986155\n9301618600" },
  { sr: "15", state: "Rajasthan", location: "Jaipur", logistic: "Professional Logistics Pvt.Ltd.", address: "A-81, 200 Ft. ByPass, Heerapura, Jaipur, Rajasthan – 302021", toll: "18002749111", contact: "Mr.Sandeep\n09252656155\n09252645321" },
  { sr: "16", state: "Sikkim", location: "Sikkim", logistic: "Professional Logistics Pvt.Ltd.", address: "Zonal Office: HN-34 Kundil Nagar Basistha Chariali, Near Parbhat Apartment, Guwahati-781029\nInfo@Packersmovers.Com", toll: "18002749111", contact: "Mr.Sisharam\n09864025200\n09864048000" },
  { sr: "17", state: "Odisha", location: "Cuttack", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No- 37, Kathajodi Rd, Badambadi Colony, Cuttack, Odisha 753009", toll: "18002749111", contact: "Mr. Anuj Kumar\n9312377781,\n9312377782" },
  { sr: "18", state: "Assam", location: "Guwahati", logistic: "Professional Logistics Pvt.Ltd.", address: "HN-34, Kundil Nagar Basistha Chariali, Near Parbhat Apartment, Guwahati-781029", toll: "18002749111", contact: "Mr.Sisharam\n09864025200\n09864048000" },
  { sr: "19", state: "Tripura", location: "Tripura", logistic: "Professional Logistics Pvt.Ltd.", address: "Zonal Office: HN-34 Kundil Nagar Basistha Chariali, Near Parbhat Apartment, Guwahati-781029\nInfo@Packersmovers.Com", toll: "18002749111", contact: "Mr.Sisharam\n09864025200\n09864048000" },
  { sr: "20", state: "Uttar Pradesh", location: "Lucknow", logistic: "Professional Logistics Pvt.Ltd.", address: "S-317, Transport Nagar, Behind RTO Office, Lucknow, Uttar Pradesh 226012", toll: "18002749111", contact: "Mr. Krishan\n09335166155\n09305166155" },
  { sr: "21", state: "Madhya Pradesh", location: "Indore", logistic: "Professional Logistics Pvt.Ltd.", address: "284 AS-3 Scheme No – 78, Vijay Nagar Indore, Madhya Pradesh", toll: "18002749111", contact: "Mr. Hardeep Singh\n09301761199\n09301432816" },
  { sr: "22", state: "West Bengal", location: "Siliguri", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No 21D, 1st Floor, Near Sai Mart, Punjabi Para Chowk, Shiv Mandir Road, Ward 13, Siliguri, West Bengal 734001", toll: "18002749111", contact: "Mr. Omprakash\n09434127311" },
  { sr: "23", state: "Gujarat", location: "Ahmedabad", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No D18, Pushp Penament, Behind Muny Hotel, Isanpur, Ahmedabad", toll: "18002749111", contact: "Mr. Sandip\n09376797600\n079 – 25753477" },
  { sr: "24", state: "Bihar", location: "Patna", logistic: "Professional Logistics Pvt.Ltd.", address: "Plot No– 4M/192, IM Colony, Chitragupta Nagar, Patna, Bihar 800026", toll: "18002749111", contact: "Mr. Das\n09304233856\n0612 – 2525821" },
  { sr: "25", state: "Nagaland", location: "Nagaland", logistic: "Professional Logistics Pvt.Ltd.", address: "Zonal Office: HN-34 Kundil Nagar Basistha Charali, Near Parinat Apartment, Guwahati-781029\nInfo@PackersMovers.Com", toll: "18002749111", contact: "Mr.Shisharam\n09864025200\n09864048000" },
  { sr: "26", state: "Meghalaya", location: "Shillong", logistic: "Professional Logistics Pvt.Ltd.", address: "Zonal Office: HN-34 Kundil Nagar Basistha Charali, Near Parinat Apartment, Guwahati-781029\nInfo@PackersMovers.Com", toll: "18002749111", contact: "Mr.Shisharam\n09864025200\n09864048000" },
  { sr: "27", state: "Mizoram", location: "Mizoram", logistic: "Professional Logistics Pvt.Ltd.", address: "Zonal Office: HN-34 Kundil Nagar Basistha Charali, Near Parinat Apartment, Guwahati-781029\nInfo@PackersMovers.Com", toll: "18002749111", contact: "Mr. Shisharam\n09864025200\n09864048000" },
  { sr: "28", state: "Andhra Pradesh", location: "Vishakhapatnam", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No.8, New Gajuwaka, Opp. High School Road, Vishakhapatnam, Andhra Pradesh- 530026", toll: "18002749111", contact: "Mr. Anuj Kumar\n9312377781\n9312377782" },
  { sr: "29", state: "Punjab", location: "Chandigarh", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No –15 & 16, Patiboot Road, Opp.- Tennis Academy, Zirakpur, Chandigarh, Punjab–140603", toll: "18002749111", contact: "Mr.Sanjeev\n09316696155\n09835696155" },
  { sr: "30", state: "West Bengal", location: "Kolkata", logistic: "Professional Logistics Pvt.Ltd.", address: "18A4/73, NORTHERN PARK, B.T. ROAD DUNLOP Kolkata-700108", toll: "18002749111", contact: "Mr.Vineet Kumar\n09133016155\n033–25106166" },
  { sr: "31", state: "Jharkhand", location: "Dhanbad", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No-45, UBD Rd, Ramson Arcade, Shastri Nagar, Dhanbad, Jharkhand – 826108", toll: "18002749111", contact: "Mr. Das\n09304233856\n0612 – 2525821" },
  { sr: "32", state: "Chhattisgarh", location: "Raipur", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop N0-67, Police Station Rd, Loha Bazar, Kabir Nagar, Raipur, Chhattisgarh – 492099", toll: "18002749111", contact: "Rajkumar Poonia\n9312377781\n9312377788" },
  { sr: "33", state: "Odisha", location: "Bhubaneswar", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No. 5, Plot No. 42, Achanya Vihar – Jaydev Vihar Rd, Doordarshan Colony, Sailpeti Nagar, Bhubaneswar, Odisha 751013", toll: "18002749111", contact: "Mr. Anuj Kumar\n9312377781\n9310377785" },
  { sr: "34", state: "West Bengal", location: "Asansol", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No-4 Asansol Station Bus Stand Road, Munshi Bazar, Asansol, West Bengal 713301", toll: "18002749111", contact: "Mr.Vinod\n09311899193\n09312512536\n9312377783" },
  { sr: "35", state: "Andhra Pradesh", location: "Secunderabad", logistic: "Professional Logistics Pvt.Ltd.", address: "Shop No -4, Block-3, 4th Shelter At 173, MFR Estates Near Old Check Post Old Bowenpally Secunderabad, Hyderabad-500011", toll: "18002749111", contact: "Mr. Prajwad\n09397022536\n040 – 3248565" },
  { sr: "36", state: "Goa", location: "Panaji", logistic: "Professional Logistics Pvt.Ltd.", address: "No 1&4 2nd Floor EDC Complex, Patto Centre, Panaji, Goa 403001", toll: "18002749111", contact: "Mr. Vedprakash\n09370939981\n9370667999" },
  { sr: "37", state: "Himachal Pradesh", location: "Dharamshala", logistic: "Professional Logistics Pvt.Ltd.", address: "49, Civil Lines Rd, Jawahar Nagar, Dharamshala, Near Bhimtal Apartment, Himachal Pradesh 176215", toll: "18002749111", contact: "Mr. Rajesh\n09999753787\n0135 – 3248885" },
];

const carouselImages = [
  { src: EwasteImg1, alt: "E-Waste recycling bins" },
  { src: EwasteImg2, alt: "E-Waste collection" },
  { src: EwasteImg3, alt: "E-Waste management" },
];

const DoIcon = () => (
  <img src={DoIconImg} alt="Do" className="ew-dos-icon" />
);

const DontIcon = () => (
  <img src={DontIconImg} alt="Don't" className="ew-dos-icon" />
);

/* ── unique sorted states ── */
const uniqueStates = [...new Set(collectionPoints.map((r) => r.state))].sort();

function IntroCarousel() {
  const [active, setActive] = useState(0);
  return (
    <div className="ew-intro-row">
      <div className="ew-intro-left">
        <h2 className="ew-intro-heading">E-Waste Management</h2>
        <p className="ew-intro-text">
          Electronic Waste, Or E-Waste, Is A Term For Electronic Products That Have Become Unwanted, Non-Working Or Obsolete, And Have Essentially Reached The End Of Their Useful Life.
        </p>
        <p className="ew-intro-text">
          As Per E-Waste Rule 2016, The E Waste Defined As 'electrical And Electronic Equipment, Whole Or In Part Discarded As Waste By The Consumer Or Bulk Consumer As Well As Rejects From Manufacturing, Refurbishment And Repair Processes.
        </p>
        <p className="ew-intro-text">
          E-Waste Contains Many Valuable, Recoverable Materials Such As Aluminium, Copper, Gold, Silver, Plastics, And Various Metals. In Order To Conserve Natural Resources And The Energy Needed To Produce New Electronic Equipment From Virgin Resources, Electronic Equipment Can Be Refurbished, Reused, And Recycled Instead Of Being Land Filled.
        </p>
        <p className="ew-intro-text">
          E-Waste Also Contains Toxic And Hazardous Materials Including Mercury, Lead, Cadmium, Beryllium, Chromium, And Chemical Flame Retardants, Which Have The Potential To Leach Into Our Soil And Water.
        </p>
      </div>
      <div className="ew-intro-right">
        <div className="ew-carousel">
          <div
            className="ew-carousel-track"
            style={{ transform: `translateX(-${active * 100}%)` }}
          >
            {carouselImages.map((img, idx) => (
              <div className="ew-carousel-slide" key={idx}>
                <img src={img.src} alt={img.alt} />
              </div>
            ))}
          </div>
        </div>
        <div className="ew-carousel-dots">
          {carouselImages.map((_, idx) => (
            <button
              key={idx}
              className={`ew-carousel-dot${active === idx ? " active" : ""}`}
              onClick={() => setActive(idx)}
              aria-label={`Slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Mobile card for a single collection point ── */
function MobileCollectionCard({ row }) {
  return (
    <div className="ew-mobile-card">
      <div className="ew-mobile-card-row">
        <span className="ew-mobile-card-label">State</span>
        <span className="ew-mobile-card-sep">:</span>
        <span className="ew-mobile-card-value">{row.state}</span>
      </div>
      <div className="ew-mobile-card-row">
        <span className="ew-mobile-card-label">Location</span>
        <span className="ew-mobile-card-sep">:</span>
        <span className="ew-mobile-card-value">{row.location}</span>
      </div>
      <div className="ew-mobile-card-row">
        <span className="ew-mobile-card-label">Logistic</span>
        <span className="ew-mobile-card-sep">:</span>
        <span className="ew-mobile-card-value">{row.logistic}</span>
      </div>
      <div className="ew-mobile-card-row">
        <span className="ew-mobile-card-label">Address</span>
        <span className="ew-mobile-card-sep">:</span>
        <span className="ew-mobile-card-value">{row.address}</span>
      </div>
      <div className="ew-mobile-card-row">
        <span className="ew-mobile-card-label">Toll Free No.</span>
        <span className="ew-mobile-card-sep">:</span>
        <span className="ew-mobile-card-value">{row.toll}</span>
      </div>
      <div className="ew-mobile-card-row">
        <span className="ew-mobile-card-label">Contact Person &amp; Name</span>
        <span className="ew-mobile-card-sep">:</span>
        <span className="ew-mobile-card-value">{row.contact}</span>
      </div>
    </div>
  );
}

/* ── Mobile collection section: dropdown + cards ── */
function MobileCollectionSection() {
  const [selectedState, setSelectedState] = useState(uniqueStates[0]);

  const filtered = collectionPoints.filter((r) => r.state === selectedState);

  return (
    <div className="ew-mobile-collection">
      {/* Dropdown with floating label border */}
      <div className="ew-mobile-dropdown-wrapper">
        <span className="ew-mobile-dropdown-label">Collection Centers</span>
        <div className="ew-state-dropdown-wrap">
          <select
            className="ew-state-select"
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
            aria-label="Select state"
          >
            {uniqueStates.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
          <ChevronDown />
        </div>
      </div>

      {/* Cards for matching rows */}
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {filtered.map((row, idx) => (
          <MobileCollectionCard key={idx} row={row} />
        ))}
      </div>
    </div>
  );
}

export default function EWasteManagement() {
  return (
    <div className="ew">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="ew-hero">
        <img className="ew-hero-bg" src={HeroBgImg} alt="E-Waste Management Hero" />
        <div className="ew-hero-overlay" />
        <div className="ew-hero-content">
          <h1 className="ew-hero-title">E-Waste Management</h1>
          <hr className="ew-hero-divider" />
          <p className="ew-hero-subtitle">
            Electronic waste, or e-waste, is a term for electronic products that have become unwanted, non-working or obsolete, and have essentially reached the end of their useful life.
          </p>
        </div>
        <nav className="ew-hero-nav">
          {["Smart Borders", "Reflex™", "Third Eye™ Perimeter", "Second Sight™", "Dweep™ Maritime", "Specialized Power"].map((item, idx) => (
            <a key={idx} href="#" className="ew-hero-nav-item">{item}</a>
          ))}
        </nav>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="ew-breadcrumb" aria-label="Breadcrumb">
        <div className="ew-breadcrumb-inner">
          <a href="/" className="ew-bc-item">Home</a>
          <span className="ew-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ew-bc-item active">E-Waste Management</span>
        </div>
      </nav>

      {/* ══ 3. INTRO ══ */}
      <section className="ew-intro-section">
        <div className="ew-inner">
          <IntroCarousel />
        </div>
      </section>

      {/* ══ 4. BENEFITS ══ */}
      <section className="ew-benefits-section">
        <div className="ew-inner">
          <h2 className="ew-section-heading">Benefit Of Recycling Of E-Waste</h2>
          <div className="ew-benefits-grid">
            {benefits.map((b, idx) => (
              <div className={`ew-benefit-card${idx % 2 === 1 ? " even" : ""}`} key={idx}>
                <p className="ew-benefit-title">{b.title}</p>
                <p className="ew-benefit-desc">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="ew-inner">
        <hr className="ew-benefits-divider" />
      </div>

      {/* ══ 5. RECYCLING OF E-WASTE ══ */}
      <section className="ew-recycling-section">
        <div className="ew-inner">
          <div className="ew-recycling-row">
            <div className="ew-recycling-left">
              <h2 className="ew-recycling-heading">Recycling Of E-Waste</h2>
              <p className="ew-recycling-text">
                The company has tied-up with the GreenZon Recycling Pvt Ltd for collection of all our E-waste on PAN India and disposes the same at their plant at R-30, UPSIDC, Industrial Area, Sikandrabad, Bulandshahar, U.P-203205 and India. Customer can reach or call on Toll Free No
                <strong> 1800-274-9111</strong>. Our representatives explain them about process of disposal and make them aware about nearest drop point available to drop the e-waste also give information about incentive we will offer to them against their end of life product. If any customer wants to handover the material from their door steps, we do send either our logistics team or E-waste Recycler India team to collect the items and channelize the same to our e-waste partner plant for final processing
              </p>
            </div>
            <div className="ew-recycling-right">
              <div className="ew-recycling-top-imgs">
                <img src={RecyclingImg1} alt="E-Waste recycling bin" />
                <img src={RecyclingImg2} alt="Green energy bulb" />
              </div>
              <img className="ew-recycling-bottom-img" src={RecyclingImg3} alt="E-Waste collection bins" />
            </div>
          </div>
          <hr className="ew-recycling-divider" />
        </div>
      </section>

      {/* ══ 6. DOS AND DON'TS ══ */}
      <section className="ew-dos-section">
        <div className="ew-inner">
          <h2 className="ew-Do-heading">Dos &amp; Don'ts</h2>
          <div className="ew-dos-row">
            <div>
              <p className="ew-dos-col-title">Dos</p>
              <ul className="ew-dos-list">
                {dos.map((item, idx) => (
                  <li key={idx}><DoIcon /><span>{item}</span></li>
                ))}
              </ul>
            </div>
            <div>
              <p className="ew-dos-col-title">Don'ts</p>
              <ul className="ew-dos-list">
                {donts.map((item, idx) => (
                  <li key={idx}><DontIcon /><span>{item}</span></li>
                ))}
              </ul>
            </div>
          </div>
          <hr className="ew-recycling-divider" />
        </div>
      </section>

      {/* ══ 7. COLLECTION CENTERS ══ */}
      <section className="ew-collection-section">
        <div className="ew-inner">
          <h2 className="ew-collection-heading">Collection Centers</h2>
          <p className="ew-collection-text">
            GreenZen Recycling Pvt Ltd has signed an agreement with <strong>Professional Logistics Pvt Ltd.</strong> for reverse logistics for Channelization of E-waste to the facility. Copy of an agreement is attached for smooth channelization of E-waste.
          </p>

          {/* ── DESKTOP: full table ── */}
          <div className="ew-desktop-collection">
            <div className="ew-table-wrap">
              <p className="ew-table-title">Collection Points</p>
              <table className="ew-table">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>States</th>
                    <th>Location</th>
                    <th>Logistic</th>
                    <th>Address</th>
                    <th>Toll Free Number</th>
                    <th>Contact Person &amp; Number</th>
                  </tr>
                </thead>
                <tbody>
                  {collectionPoints.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.sr}</td>
                      <td>{row.state}</td>
                      <td>{row.location}</td>
                      <td>{row.logistic}</td>
                      <td style={{ whiteSpace: "pre-line" }}>{row.address}</td>
                      <td>{row.toll}</td>
                      <td style={{ whiteSpace: "pre-line" }}>{row.contact}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* ── MOBILE: dropdown + cards ── */}
          <MobileCollectionSection />

          <div className="ew-contact-footer">
            <p className="para">For All Related Queries Contact</p>
            <p className="para"><strong>Mr. Shubham Sarkar</strong> (Leader QHSE And Sustainability)</p>
            <p className="para"><strong>Tel:</strong> +91(0)23035422</p>
            <p><strong>Email Id:</strong> Safety@Adorpower.Com</p>
          </div>
        </div>
      </section>

    </div>
  );
}